import axios from 'axios';
import { createApp } from 'vue';
import Vue3TouchEvents from 'vue3-touch-events';
import VueTour from 'v3-tour';
import { ObserveVisibility } from 'vue-observe-visibility';
import VueCookies from 'vue-cookies';
import { mapGetters } from 'vuex';
import { store } from '@store';
import * as Popper from '@popperjs/core';
import App from './App.vue';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

global.Popper = Popper;

global.axios = axios;
function importAll(r) {
   r.keys().forEach(r);
}

importAll(require.context('../assets/partner-logos', false, /\.(png|avif|webp|svg|)$/));

// Vue
const app = createApp(App);
app.use(VueCookies);
app.use(VueTour);
app.use(Vue3TouchEvents);
app.use(store);
app.directive('observe-visibility', ObserveVisibility);
app.mixin({
   computed: {
      ...mapGetters(['breakpoint', 'lte']),
   },
});

app.mount('#app');
